import { VacancySelectedCandidatesPage } from '@pages/vacancy';
import { createMeta } from '@shared/utils';

export function meta() {
  return createMeta('Выбранные кандидаты', 'Выбранные кандидаты по вакансии');
}

export default VacancySelectedCandidatesPage;
